// Hard-coded, per-tenant exceptions to otherwise uniform behaviour.
//
// These are deliberate stop-gaps agreed with the practice, not configuration:
// each one carries who asked for it and why, so it can be removed once the
// underlying problem is solved rather than quietly becoming permanent.

// TEMP (requested by Dalen, 16-07-2026): tenant 200 (Centric) has ongoing
// trouble with the DNA / No-show status feeding into manual fixes, so the
// status is hidden from them — on the appointments board (KIN-1591 era) and in
// the appointments report filter (KIN-1673). Hidden from the pickers only: a
// record that already carries the status still renders wherever it appears.
const HIDE_NO_SHOW_TENANT = "200";

export const isNoShowHidden = () =>
  String(localStorage.getItem("kinesin-tenant")) === HIDE_NO_SHOW_TENANT;
